import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course04 from "../../../course/course-04/course";
import lesson0402 from "../lesson-02/lesson";
import lesson0403 from "../lesson-03/lesson";
import lesson0404 from "../lesson-04/lesson";
import lesson0406 from "../lesson-06/lesson";
import lesson0407 from "../lesson-07/lesson";
import lesson0409 from "../lesson-09/lesson";
import lesson0418 from "../lesson-18/lesson";
import lesson0419 from "../lesson-19/lesson";
import lesson0420 from "../lesson-20/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "ddfd22ce-ad8d-4eaf-9ab7-b118efad7a0f",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0402),
    lesson: lesson0402,
  },
  {
    id: "aaa97b8a-7fc7-4a96-ada8-8cfd89d98747",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0403),
    lesson: lesson0403,
  },
  {
    id: "bd57c902-0597-4a88-abb9-b0e0b17a2596",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0404),
    lesson: lesson0404,
  },
  {
    id: "881f5ae4-92f0-42af-b3fb-530c7a4c0800",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0406),
    lesson: lesson0406,
  },
  {
    id: "22e28e36-5bab-42c7-815d-c8d2c21781a4",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0407),
    lesson: lesson0407,
  },
  {
    id: "868e45b6-1f8d-419d-b3ff-e4847b795ac3",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0409),
    lesson: lesson0409,
  },
  {
    id: "b60c0887-948c-4ae3-bbd3-90b1e74a4680",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0418),
    lesson: lesson0418,
  },
  {
    id: "78297a7f-9d88-42f5-9d8a-7134c5e55acb",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0419),
    lesson: lesson0419,
  },
  {
    id: "171fdbec-e307-45e5-b9c3-1da37d0e82d9",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0420),
    lesson: lesson0420,
  },
];

export default lessonLinks;
